<template>
  <div>
    <remCom :datetime="datetime" v-if="clientWidth>600" />
    <baseCom v-else />
  </div>
</template>
  
<script>
import "@/utils/rem";
import remCom from "./components/remCom.vue";
import baseCom from "./components/baseCom.vue";
import {mapState} from 'vuex'
export default {
  name: "page-box",
  computed: {
		...mapState(['clientWidth']),
	},
  components: {
    remCom,
    baseCom
  },
  data() {
    return {
      datetime:'',
    };
  },
  created(){
    this.datetime = this.getDate()
  },
  methods: {
   getDate(){
    const now = new Date();
    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const day = ('0' + now.getDate()).slice(-2);
    const weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    const nowWeek = weeks[new Date().getDay()];
    return year + '年' + month + '月' + day + '日 ' + nowWeek
   }
  }
};
</script>
